import { render } from "./QuestionModal.vue?vue&type=template&id=5c7a1772&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"

import "./QuestionModal.vue?vue&type=style&index=0&id=5c7a1772&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7a1772"]])

export default __exports__